import styled from "styled-components";

export const Money = styled.span`
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: #000000;
  font-family: "Inter Bold"
`;